'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/react/index.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/react/index.js
// module chunks = 168707334958949